import React, {Component, useState} from "react";
import moment from "moment";
import 'moment/locale/tr';
import generateFakeData from "./react-calendar-timeline/generate-fake-data";
import Timeline, {DateHeader, SidebarHeader, TimelineHeaders} from 'react-calendar-timeline/lib';
import "react-calendar-timeline/lib/Timeline.css";

import "./react-calendar-timeline/timeline_style.css";

import InfoLabel from "./react-calendar-timeline/InfoLabel";
import MalzemeListesiOnizleme from "./MalzemeListesiOnizleme";
import TaskListPopup from "./TaskListPopup";
import axios from "axios";
import { api } from "./api/client";



moment().locale('tr');

let getTimeLineDatas = async () => {
    //console.log('test',moment('2023-02-22'+' '+'18:00:00').valueOf());
    //console.log('test2', moment().startOf('day').valueOf() + 8 * 60 * 60 * 1000)
    const res = await api.get('/timeline', { params: { start: moment().startOf('month').format('YYYY-MM-DD'), end: moment().startOf('month').add(1,'month').format('YYYY-MM-DD') } })
    const data = res.data;
    let itemz = [];
    let no = 0;
    data.forEach((d) => {
        let its = {
            id: no++,
            group: d.id,
            firma: d.musteri,
            start: moment(d.is_emri_tarihi + " " + d.start).valueOf(),
            end: moment(d.is_emri_tarihi + " " + d.end).valueOf(),
            canMove: false,
            canResize: false,
            itemProps: {
                // these optional attributes are passed to the root <div /> of each item as <div {...itemProps} />
                'aria-hidden': true,
                onDoubleClick: () => {
                    console.log('You clicked double!')
                },
                className: 'weekend',
                style: {
                    background: 'orange'
                }
            },
            selectedBgColor: '#f60',
            bgColor: '#ccc'
        }
        itemz.push(its);
    })
    return itemz;
}
let keys = {
    groupIdKey: "id",
    groupTitleKey: "title",
    groupRightTitleKey: "rightTitle",
    itemIdKey: "id",
    itemTitleKey: "title",
    itemDivTitleKey: "title",
    itemGroupKey: "group",
    itemTimeStartKey: "start",
    itemTimeEndKey: "end",
    groupLabelKey: "title"
};


export default function TaskTable() {



    const [groups, setGroups] = useState([]);
    const [items, setItems] = useState([]);
    let [defaultTimeStart, setDefaultTimeStart] = useState(moment()
        .startOf("month")
        .toDate());
    let [defaultTimeEnd, setDefaultTimeEnd] = useState(moment()
        .startOf("month")
        .add(1, "month")
        .toDate());
    const [visibleTimeStart, setVisibleTimeStart] = useState(moment()
        .startOf("month")
        .valueOf());
    const [visibleTimeEnd, setVisibleTimeEnd] = useState(moment()
        .startOf("month")
        .add("1", "month")
        .valueOf());
    const [showModal, setShowModal] = useState(false);
    const [unit, setUnit] = useState('month');
    const [draggedItem, setDraggedItem] = useState('month');



    const getDataz = async () => {

        const res = await api.get('/lookups/users', { params: { limit: 2000, scope: 'takvim' } })
        const data = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        let groupz = data.map(d => ({
            "id": d.id,
            "title": d.root ? d.title : d.isim + " " + d.soyisim,

        }))
        setGroups(groupz)
    };


    const getTimeLineDataz = async () => {
        //console.log('test',moment('2023-02-22'+' '+'18:00:00').valueOf());
        //console.log('test2', moment().startOf('day').valueOf() + 8 * 60 * 60 * 1000)
        const res = await api.get('/timeline', { params: { start: moment().startOf('month').format('YYYY-MM-DD'), end: moment().startOf('month').add(1,'month').format('YYYY-MM-DD') } })
        const data = res.data;
        let itemz = [];
        let no = 0;
        data.forEach((d) => {
            let its = {
                id: no++,
                group: d.id,
                firma: d.musteri,
                start: moment(d.is_emri_tarihi + " " + d.start).valueOf(),
                end: moment(d.is_emri_tarihi + " " + d.end).valueOf(),
                canMove: false,
                canResize: true,
                itemProps: {
                    // these optional attributes are passed to the root <div /> of each item as <div {...itemProps} />
                    'aria-hidden': true,
                    onDoubleClick: () => {
                        console.log('You clicked double!')
                    },
                    className: 'weekend',
                    style: {
                        background: 'orange'
                    }
                },
                selectedBgColor: '#f60',
                bgColor: '#ccc'
            }
            itemz.push(its);
        })
        setItems(itemz)
    }

    useState(()=>{
        getTimeLineDataz() ;
        getDataz();
    },[])

    const handleDoubleClick = (group, time, e) => {
        console.log('handleDoubleClick', group, time, e)
        //setOpenModal(true})
        /*var newItems = [...this.state.items, {
            id: this.state.items.length+1,
            group: group,
            title: '3',
            start: moment(time).startOf('day').valueOf(),
            end: moment(time).startOf('day').valueOf() + 1 * 24 * 60 * 60 * 1000,
            canResize: 'both',
            // canMove: startValue > new Date().getTime(),
            // canResize: startValue > new Date().getTime() ? (endValue > new Date().getTime() ? 'both' : 'left') : (endValue > new Date().getTime() ? 'right' : false),
            //className: 'item-weekend',
            itemProps: {
            }
        }]/
        this.setState({
            items: newItems
        })*/
    }




    //nex,prev, date filter buttons

    const onPrevClick = () => {
        if (unit === "week") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(-1, "week")
                .startOf("week")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(-1, "week")
                .endOf("week")
                .valueOf();

            setVisibleTimeStart(newVisibleTimeStart);
            setVisibleTimeEnd(newVisibleTimeEnd);

        }
        if (unit === "month") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(-1, "month")
                .startOf("month")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(-1, "month")
                .endOf("month")
                .valueOf();
            setVisibleTimeStart(newVisibleTimeStart);
            setVisibleTimeEnd(newVisibleTimeEnd);
        }
        if (unit === "year") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(-1, "year")
                .startOf("year")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(-1, "year")
                .endOf("year")
                .valueOf();
            setVisibleTimeStart(newVisibleTimeStart);
            setVisibleTimeEnd(newVisibleTimeEnd);
        }
    };

    const onNextClick = () => {
        if (unit === "week") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(1, "week")
                .startOf("week")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(1, "week")
                .endOf("week")
                .valueOf();
            setVisibleTimeStart(newVisibleTimeStart);
            setVisibleTimeEnd(newVisibleTimeEnd);
        }
        if (unit === "month") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(1, "month")
                .startOf("month")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(1, "month")
                .endOf("month")
                .valueOf();
            setVisibleTimeStart(newVisibleTimeStart);
            setVisibleTimeEnd(newVisibleTimeEnd);
        }
        if (unit === "year") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(1, "year")
                .startOf("year")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(1, "year")
                .endOf("year")
                .valueOf();
            setVisibleTimeStart(newVisibleTimeStart);
            setVisibleTimeEnd(newVisibleTimeEnd);
        }
    };

    const handleTimeChange = (visibleTimeStart, visibleTimeEnd) => {
        setVisibleTimeStart(visibleTimeStart);
        setVisibleTimeEnd(visibleTimeEnd);
        //scrolling:true
    };

    const handleTimeHeaderChange = unit => {
        setUnit(unit);
        if (unit === "week") {
            setVisibleTimeStart(moment()
                .startOf("week")
                .valueOf());
            setVisibleTimeEnd(moment()
                .endOf("week")
                .valueOf());
        }
        if (unit === "month") {
            setVisibleTimeStart(moment()
                .startOf("month")
                .valueOf());
            setVisibleTimeEnd(moment()
                .endOf("month")
                .valueOf());
        }
        if (unit === "year") {
            setVisibleTimeStart(moment()
                .startOf("year")
                .valueOf());
            setVisibleTimeEnd(moment()
                .endOf("year")
                .valueOf());
        }
    };

    //custom item
    const itemRenderer = ({item, timelineContext, itemContext, getItemProps, getResizeProps}) => {
        const {left: leftResizeProps, right: rightResizeProps} = getResizeProps();
        const backgroundColor = itemContext.selected ? (itemContext.dragging ? "blue" : item.selectedBgColor) : item.bgColor;
        const borderColor = itemContext.resizing ? "blue" : item.color;
        return (
            <div
                {...getItemProps({
                    style: {
                        backgroundColor,
                        color: item.color,
                        borderRadius: 4,
                        borderLeftWidth: itemContext.selected ? 3 : 1,
                        borderRightWidth: itemContext.selected ? 3 : 1,
                        width: '50%',
                        border: itemContext.selected ? 'dashed 1px rgba(0,0,0,0.3)' : 'none',
                        boxShadow: `0 1px 5px 0 rgba(0, 0, 0, 0.2),
                     0 2px 2px 0 rgba(0, 0, 0, 0.14),
                     0 3px 1px -2px rgba(0, 0, 0, 0.12)`
                    },

                })}
            >
                <div
                    style={{

                        overflow: "hidden",
                        paddingLeft: 0,
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    <TaskListPopup  itemC={item}/>
                </div>
            </div>
        );
    };

    defaultTimeStart = moment().add(0, 'hour');
    defaultTimeEnd = moment().add(6, 'hour');
    const defaultVisableTimeEnd = moment().add(24, 'hour')
    const defaultTimeRange = defaultTimeEnd - defaultTimeStart;


    return (
        <div>
            <button onClick={onPrevClick}>{"< Geri"}</button>
            <button onClick={onNextClick}>{"İleri >"}</button>
            <button onClick={() => handleTimeHeaderChange("week")}>
                {"Hafta"}
            </button>
            <button onClick={() => handleTimeHeaderChange("month")}>
                {"Ay"}
            </button>
            <button onClick={() => handleTimeHeaderChange("year")}>
                {"Yıl"}
            </button>
            {groups.length!=0 && items.length!=0 && <Timeline
                groups={groups}
                items={items}
                keys={keys}

                sidebarWidth={200}
                itemTouchSendsClick={false}
                stackItems
                itemHeightRatio={0.75}
                defaultTimeStart={moment().add(-20, "year")}
                defaultTimeEnd={moment()}
                itemRenderer={itemRenderer}
                onItemClick={() => {
                    return false
                }}
                onCanvasDoubleClick={() => {
                    return false
                }}
                onCanvasClick={() => {
                    return false
                }}

                minZoom={defaultTimeRange}
                maxZoom={defaultTimeRange}

                fixedHeader='fixed'
                fullUpdate={true}
                //onItemContextMenu={this.handleItemContextMenu}
                visibleTimeStart={visibleTimeStart}
                visibleTimeEnd={visibleTimeEnd}
                onTimeChange={(_start, _end, updateScrollCanvas) => {
                    if (_start > defaultTimeStart && _end < defaultVisableTimeEnd)
                        updateScrollCanvas(_start, _end);


                }}
            >

            </Timeline> }
            { /*draggedItem && (
                <InfoLabel
                    item={draggedItem.item}
                    group={draggedItem.group}
                    time={draggedItem.time}
                />
            ) */}
        </div>
    );

}
